import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Paper,
} from '@mui/material';
import { AppState } from '../../store';
import { setModalClosed } from '../../store/modal/actions';

const UniversalModal = () => {
  const modalProperties = useSelector((state: AppState) => state.modal);
  const { open, message, accept, cancel, acceptButtonText, cancelButtonText } = modalProperties;
  const dispatch = useDispatch();

  const handleCancel = () => {
    if (typeof cancel === 'function') cancel();
    dispatch(setModalClosed());
  };
  const handleAccept = () => {
    if (typeof accept === 'function') accept();
    dispatch(setModalClosed());
  };

  return (
    <Dialog open={open} PaperComponent={Paper}>
      <Paper>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {cancel && (
            <Button onClick={handleCancel} color="primary">
              {cancelButtonText || 'Cancel'}
            </Button>
          )}
          {accept && (
            <Button onClick={handleAccept} color="primary">
              {acceptButtonText || 'Confirm'}
            </Button>
          )}
        </DialogActions>
      </Paper>
    </Dialog>
  );
};
export default UniversalModal;
